import React, { PureComponent } from 'react';
import './index.scss';
import CommonModal from '@/components/CommonModal';
import _ from 'lodash';
import {BASEURL, downLoadPage} from '@/utils/util';

export default class Prize extends React.Component {
  state = {
    modalVisible: false,
    instructionModalVisible: false,
  }
 
componentWillReceiveProps(nextProps){
  if(this.props !== nextProps && (nextProps.winPrizeId && nextProps.winPrizeId === nextProps.prizeId) && nextProps.showPrizeModal ){
   this.setState({modalVisible: true})
  }
}
  closeModal = () => {
    const { closePrizeModal } = this.props;
    this.setState({ modalVisible: false } )
    closePrizeModal && closePrizeModal();
  }

  hidePrizeModal = ()=>{
    this.setState({ modalVisible: false } )
  }
  goToCouponPage = () => {
    const { isCRGT, isWXMp } = window.crgt;
    if (isCRGT) {
      window.crgt.router.openUrl({
        url: `${BASEURL}/couponPage`,
      });
      return;
    }
    if (isWXMp) {
      window.wx.miniProgram.navigateTo({
        url: `/pages/h5/index?url=${encodeURIComponent(`${BASEURL}/couponPage/#/`)}`,
      });
      return;
    }
    downLoadPage()
  }

  showInstructionModal = () => {
    const {instructionModalVisible} = this.state;
    this.hidePrizeModal();
    if(instructionModalVisible) return;
    this.setState({ instructionModalVisible: true })
  }

  closeInstructionModal = () => {
    const { closePrizeModal } = this.props;
    this.setState({ instructionModalVisible: false });
    closePrizeModal && closePrizeModal();
  }

  getModalContent = () => {
    const { drawModalFontColor, drawPrizeFontColor, prizeDesc, prizeType,title, prizeInfo, drawPrizeBgUrl, drawPrizeButtonUrl="https://static.ccrgt.com/images/3affe1af-152f-41e2-ad7a-1d05e38996d3.png", drawModalTopImgUrl, drawModalButtonImgUrl} = this.props;
    let renderHtml = '';
    if (prizeType === 'COUPONPARTNER') {
      renderHtml = (
        <div className="prize-modal-container" style={{color: drawModalFontColor}}>
          {!_.isEmpty(drawModalTopImgUrl) && <div className="prize-modal-top"><img src={drawModalTopImgUrl} /></div>}
          <div className="prize-modal-title">恭喜您 中奖啦！</div>
          {prizeInfo && prizeInfo.map(item => (
            <div className="prize-modal-content" style={{ backgroundImage: drawPrizeBgUrl && `url(${drawPrizeBgUrl})` }}>
              <div className="prize-modal-content-left" style={{color: drawPrizeFontColor}}>
              <div className="title">{title}</div>
              {item.prizeCode && <div className="desc">兑换码：{item.prizeCode}</div>}
              {item.prizePass && <div className="desc">密码：{item.prizePass}</div>}
              {item.expireTime &&<div className="desc">有效期：{item.expireTime}</div>}
              </div>
              <div className="prize-modal-content-right" onClick={this.showInstructionModal}>
              <img src={drawPrizeButtonUrl} />
              </div>
              
            </div>
          ))}
          <div className="prize-modal-button" style={{ backgroundImage: drawModalButtonImgUrl && `url(${drawModalButtonImgUrl})` }} onClick={this.closeModal}></div>
          {!_.isEmpty(prizeDesc) && <div className="prize-modal-desc">{prizeDesc}</div>}
        </div>
      );
    } else {
      renderHtml = (
        <div className="prize-modal-container" style={{color: drawModalFontColor}}>
          {!_.isEmpty(drawModalTopImgUrl) && <div className="prize-modal-top"><img src={drawModalTopImgUrl} /></div>}
          <div className="prize-modal-title">恭喜您 中奖啦！</div>
          {prizeInfo && prizeInfo.map(item => (
            <div className="prize-modal-content coupon" style={{ backgroundImage: drawPrizeBgUrl && `url(${drawPrizeBgUrl})` }}>
               <div className="prize-modal-content-left" style={{color: drawPrizeFontColor}}>
              <div className="title">{title}</div>
              {item.expireTime && <div className="desc">有效期：{item.expireTime}</div>}
              <div className="desc" >已放入我的卡券， 请前往查看</div>
              </div>
              <div className="prize-modal-content-right" onClick={this.goToCouponPage}><img src={drawPrizeButtonUrl} /></div>
            </div>
          ))}
          <div className="prize-modal-button" style={{ backgroundImage: drawModalButtonImgUrl&&`url(${drawModalButtonImgUrl})` }} onClick={this.closeModal}></div>
          {!_.isEmpty(prizeDesc) && <div className="prize-modal-desc">{prizeDesc}</div>}
        </div>
      );
    }
    return renderHtml;
  }
  renderText = (text) => {
    if (!_.isEmpty(text)) {
      const desc = text.split('；');
      return desc.map((item, index) => {
        if (_.isEmpty(item)) {
          return (<></>)
        }
        return (<p key={index}>{item}</p>)
      })
    }
    return text;
  }
  getInstructionModalContent = () => {
    const { drawModalFontColor, instructionTitle, instructionDesc, drawModalTopImgUrl } = this.props;
    let renderHtml = '';
    renderHtml = (
      <div className="prize-modal-container" style={{color: drawModalFontColor}}>
        {!_.isEmpty(drawModalTopImgUrl) && <div className="prize-modal-top"><img src={drawModalTopImgUrl} /></div>}
        <div className="prize-modal-title">{instructionTitle}</div>
        {this.renderText(instructionDesc)}
      </div>
    );
    return renderHtml;
  }
  render() {
    const { prizeId, modalBgColor, prizeImgUrl, } = this.props;
    const { modalVisible, instructionModalVisible } = this.state;
    return (<>
      <div key={prizeId} className="draw-card"><img src={prizeImgUrl} /></div>
      <CommonModal closeBtn visible={modalVisible} modalBgColor={modalBgColor} onClose={this.closeModal} >{this.getModalContent()}</CommonModal>
      <CommonModal closeBtn visible={instructionModalVisible} modalBgColor={modalBgColor} onClose={this.closeInstructionModal} >{this.getInstructionModalContent()}</CommonModal>
    </>
    )
  }
}